import TableStore from 'data/stores/TableStore';
import clientsRepo from 'data/repositories/ClientsRepo';
import to from 'lib/awaitTo';
import { Toast } from 'lib/dialogs';

class ClientsStore extends TableStore<any> {
  create = async (data: any) => {
    const [res] = await to(clientsRepo.create(data));

    if (res) {
      Toast.fire({
        type: 'success',
        title: 'Uspešno je dodat upis!'
      });
      this.fetch(this.queryParams);
      this.closeModalForm();
    }
  };

  update = async (data: any, id: string) => {
    const [res] = await to(clientsRepo.update(id, data));

    if (res) {
      Toast.fire({
        type: 'success',
        title: 'Uspešna je izmena!'
      });
      this.fetch(this.queryParams);
      this.closeModalForm();
    }
  };

  delete = async (id: string) => {
    const [res] = await to(clientsRepo.delete(id));

    if (res) {
      setTimeout(() => {
        Toast.fire({
          type: 'success',
          title: 'Uspešna je obrisana!'
        });
      }, 500);
      this.fetch(this.queryParams);
    }
  };
}

export const clientsStore = new ClientsStore(clientsRepo);
export default ClientsStore;
